import React from "react";
import PropTypes from "prop-types";

import styles from "./HomepageHeader.module.css";
import classnames from "classnames";

const HomepageHeader = ({ text, isCaps, isCardHeader = false, ...other }) => {
  if (!text) return null;

  return (
    <h2
      className={classnames(styles.header, {
        [styles.isCardHeader]: isCardHeader,
      })}
      {...other}
      style={isCaps ? { textTransform: "uppercase" } : null}
    >
      {text}
    </h2>
  );
};

export default HomepageHeader;

HomepageHeader.propTypes = {
  text: PropTypes.string.isRequired,
  isCaps: PropTypes.bool,
  isCardHeader: PropTypes.bool,
  styles: PropTypes.object,
};
